import React from 'react';
import pt from 'prop-types';

import Flash from 'components/flash';
import Link from 'components/link';
import LoadingBar from 'components/loading/bar';
import Logo from 'partners/components/logo';

import SignupIllustration from './illustration';
import SignupStepper from './stepper';
import './signup.scss';

export default class SignupLayout extends React.PureComponent {
  static propTypes = {
    flash: pt.object,
    step: pt.string,
    onGoToStep: pt.func,
    canGoBack: pt.bool,
    children: pt.node,
  };

  render() {
    const { flash, step, onGoToStep, canGoBack, children } = this.props;

    return (
      <div className="auth-split signup-split">
        <LoadingBar />
        <Flash {...flash} />

        <SignupIllustration />

        <div className="auth-split_panel">
          <div className="signup-panel-header">
            {step && (
              <SignupStepper
                step={step}
                onGoToStep={onGoToStep}
                canGoBack={canGoBack}
              />
            )}

            <Link className="auth-toplink" to="/login">
              Login instead
            </Link>
          </div>

          <div className="auth-split_form auth-form-fields">
            <div className="logo-container">
              <Logo />
            </div>

            {children}
          </div>
        </div>
      </div>
    );
  }
}
